import { Group, Loader } from "@mantine/core";
import { StatusSymbol, StatusSymbolColor } from "../../../Icons/StatusSymbol";

interface TitleWithStatusSymbolProps {
  title: string;
  isLoading: boolean;
  isGreen: boolean;
  isRed: boolean;
}

function TitleWithStatusSymbol({
  title,
  isLoading,
  isGreen,
  isRed
}: TitleWithStatusSymbolProps) {
  let statusSymbolColor = "#FFF";

  if (isGreen) {
    statusSymbolColor = StatusSymbolColor.Green;
  } else if (isRed) {
    statusSymbolColor = StatusSymbolColor.Red;
  }

  return (
    <Group align="center" className="TitleWithStatusSymbol" gap={0}>
      {isLoading ? (
        <Loader mr="xs" size="xs" />
      ) : (
        <StatusSymbol color={statusSymbolColor} />
      )}
      {title}
    </Group>
  );
}

export { TitleWithStatusSymbol, TitleWithStatusSymbolProps };
